let r, l;
const n = (e) => {
  r = e;
}, s = (e) => {
  l = e.toLowerCase();
}, u = (e) => {
  if (!r)
    return console.warn("Cloud data not set"), !1;
  if (!l)
    return console.warn("Country not set"), !1;
  let o = r.supportCountries;
  return e ? o = o.filter((t) => t.type.includes("all") || t.type.includes(e)) : o = o.filter((t) => t.type.includes("all")), !!o.find((t) => t.code.toLowerCase() === l);
};
export {
  u as isSupport,
  n as setCloudData,
  s as setCountry
};
